import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import sourceChart from './sourceChart';
import sourceComparChart from './sourceComparChart';
import { channelTypelist, salesStatusMonthlist } from '@/api/PMS/customerService/analyticStatistics.js';
export default {
  components: {
    sourceChart: sourceChart,
    sourceComparChart: sourceComparChart
  },
  data: function data() {
    return {
      listQuery: {
        beginDate: null,
        endDate: null
      },
      dates: [],
      chartData1: [],
      lendName1: [],
      total: 0,
      xAxisData: [],
      lendName2: [],
      chartData2: []
    };
  },
  created: function created() {
    this.handleFilter();
  },
  methods: {
    handleFilter: function handleFilter() {
      var _this = this;

      if (this.listQuery.beginDate > this.listQuery.endDate) {
        this.Alert({
          alertType: 'error',
          message: '开始日期不能大于结束日期！'
        });
        return;
      }

      channelTypelist(this.listQuery).then(function (response) {
        _this.chartData1 = [];
        _this.lendName1 = [];
        _this.total = response.data.data.totalNumber;
        response.data.data.detailList.forEach(function (element) {
          _this.chartData1.push(element.number);

          _this.lendName1.push(element.dicName);
        });
      });
      salesStatusMonthlist(this.listQuery).then(function (response) {
        _this.chartData2 = [];
        _this.xAxisData = [];
        _this.lendName2 = [];
        response.data.data.forEach(function (element, index) {
          if (index === 0) {
            element.detailList.forEach(function (item) {
              _this.lendName2.push(item.dicName);
            });
          }

          _this.xAxisData.push(element.month);
        });

        _this.lendName2.forEach(function (element) {
          var dt = [];
          response.data.data.forEach(function (k, index) {
            k.detailList.forEach(function (g, index) {
              if (element === g.dicName) {
                dt.push(g.number);
              }
            });
          });

          _this.chartData2.push(dt);
        });
      });
    }
  }
};